module.exports = __webpack_public_path__ + "static/img/icon2.5bf1cfac.svg";